// extracted by mini-css-extract-plugin
module.exports = {"vi-offline":"index__vi-offline--1fCtR","text":"index__text--3nmZs","btn":"index__btn--2jg26"};